// **********************************************************************
// This file was generated by a TAF parser!
// TAF version 2.1.7.7
// Generated from `1665194120575.jce'
// **********************************************************************
import { Taf } from '@huyafed/taf-network';

var HUYAVIDEO = HUYAVIDEO || {};


HUYAVIDEO.InvokeCode = 
{
    success: 0,
    paramLose: 1,
    paramInvalid: 2,
    objNotExist: 3,
    objAlreadyExist: 4,
    sysError: 5,
    loadingData: 6
};


HUYAVIDEO.UserId = function()
{
    this.lUid = 0;
    this.sGuid = "";
    this.sToken = "";
    this.sHuYaUA = "";
    this.sCookie = "";
    this.iTokenType = 0;
    this.sUserIp = "";
};
HUYAVIDEO.UserId.prototype._clone = function () { return new HUYAVIDEO.UserId(); }
HUYAVIDEO.UserId.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYAVIDEO.UserId.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYAVIDEO.UserId.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeString(1, this.sGuid);
    os.writeString(2, this.sToken);
    os.writeString(3, this.sHuYaUA);
    os.writeString(4, this.sCookie);
    os.writeInt32(5, this.iTokenType);
    os.writeString(6, this.sUserIp);
};

HUYAVIDEO.UserId.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.sGuid= is.readString(1, false, this.sGuid);
    this.sToken= is.readString(2, false, this.sToken);
    this.sHuYaUA= is.readString(3, false, this.sHuYaUA);
    this.sCookie= is.readString(4, false, this.sCookie);
    this.iTokenType= is.readInt32(5, false, this.iTokenType);
    this.sUserIp= is.readString(6, false, this.sUserIp);
};

HUYAVIDEO.VideoReqHeader = function()
{
    this.userId = new HUYAVIDEO.UserId();
    this.byPass = "default";
};
HUYAVIDEO.VideoReqHeader.prototype._clone = function () { return new HUYAVIDEO.VideoReqHeader(); }
HUYAVIDEO.VideoReqHeader.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYAVIDEO.VideoReqHeader.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYAVIDEO.VideoReqHeader.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.userId);
    os.writeString(1, this.byPass);
};

HUYAVIDEO.VideoReqHeader.prototype.readFrom = function (is)
{
    this.userId= is.readStruct(0, false, this.userId);
    this.byPass= is.readString(1, false, this.byPass);
};

HUYAVIDEO.VideoRespHeader = function()
{
    this.reqHeader = new HUYAVIDEO.VideoReqHeader();
    this.code = 0;
    this.msg = "";
};
HUYAVIDEO.VideoRespHeader.prototype._clone = function () { return new HUYAVIDEO.VideoRespHeader(); }
HUYAVIDEO.VideoRespHeader.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYAVIDEO.VideoRespHeader.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYAVIDEO.VideoRespHeader.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.reqHeader);
    os.writeInt32(1, this.code);
    os.writeString(2, this.msg);
};

HUYAVIDEO.VideoRespHeader.prototype.readFrom = function (is)
{
    this.reqHeader= is.readStruct(0, false, this.reqHeader);
    this.code= is.readInt32(1, false, this.code);
    this.msg= is.readString(2, false, this.msg);
};

HUYAVIDEO.VideoLiveBarrage = function()
{
    this.content = "";
    this.uid = 0;
    this.pid = 0;
    this.sendTime = 0;
    this.relativeTime = 0;
};
HUYAVIDEO.VideoLiveBarrage.prototype._clone = function () { return new HUYAVIDEO.VideoLiveBarrage(); }
HUYAVIDEO.VideoLiveBarrage.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYAVIDEO.VideoLiveBarrage.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYAVIDEO.VideoLiveBarrage.prototype.writeTo = function (os)
{
    os.writeString(0, this.content);
    os.writeInt64(1, this.uid);
    os.writeInt64(2, this.pid);
    os.writeInt64(3, this.sendTime);
    os.writeInt64(4, this.relativeTime);
};

HUYAVIDEO.VideoLiveBarrage.prototype.readFrom = function (is)
{
    this.content= is.readString(0, false, this.content);
    this.uid= is.readInt64(1, false, this.uid);
    this.pid= is.readInt64(2, false, this.pid);
    this.sendTime= is.readInt64(3, false, this.sendTime);
    this.relativeTime= is.readInt64(4, false, this.relativeTime);
};

HUYAVIDEO.GetVideoLiveBarrageRsp = function()
{
    this.respHeader = new HUYAVIDEO.VideoRespHeader();
    this.list = new Taf.Vector(new HUYAVIDEO.VideoLiveBarrage());
};
HUYAVIDEO.GetVideoLiveBarrageRsp.prototype._clone = function () { return new HUYAVIDEO.GetVideoLiveBarrageRsp(); }
HUYAVIDEO.GetVideoLiveBarrageRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYAVIDEO.GetVideoLiveBarrageRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYAVIDEO.GetVideoLiveBarrageRsp.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.respHeader);
    os.writeVector(1, this.list);
};

HUYAVIDEO.GetVideoLiveBarrageRsp.prototype.readFrom = function (is)
{
    this.respHeader= is.readStruct(0, false, this.respHeader);
    this.list= is.readVector(1, false, this.list);
};

HUYAVIDEO.GetVideoLiveBarrageReq = function()
{
    this.reqHeader = new HUYAVIDEO.VideoReqHeader();
    this.vid = 0;
    this.startDuration = 0;
    this.endDuration = 0;
};
HUYAVIDEO.GetVideoLiveBarrageReq.prototype._clone = function () { return new HUYAVIDEO.GetVideoLiveBarrageReq(); }
HUYAVIDEO.GetVideoLiveBarrageReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYAVIDEO.GetVideoLiveBarrageReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYAVIDEO.GetVideoLiveBarrageReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.reqHeader);
    os.writeInt64(1, this.vid);
    os.writeInt32(2, this.startDuration);
    os.writeInt32(3, this.endDuration);
};

HUYAVIDEO.GetVideoLiveBarrageReq.prototype.readFrom = function (is)
{
    this.reqHeader= is.readStruct(0, false, this.reqHeader);
    this.vid= is.readInt64(1, false, this.vid);
    this.startDuration= is.readInt32(2, false, this.startDuration);
    this.endDuration= is.readInt32(3, false, this.endDuration);
};

export default HUYAVIDEO;